// @flow

import * as React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useLocale } from '../../hooks/locale.js';
import { sortDescriptor } from './sharedDescriptors';

export const DevelopmentsSort = (): React.Node => {
  const { t } = useLocale();
  const DEFAULT_ID = 'createdAt';
  const defaultValue = { sortBy: null, sortDirection: null };
  const [sort, setSort, flushSort] = sortDescriptor.useState();

  return (
    <FormControl variant="outlined">
      <Select
        value={sort.sortBy ?? DEFAULT_ID}
        onChange={e => {
          if (e.target.value === DEFAULT_ID) {
            setSort(defaultValue);
          } else {
            setSort({
              sortBy: e.target.value,
              sortDirection: 'ASC',
            });
          }
          flushSort();
        }}
        // autoWidth
        fullWidth={true}
      >
        <MenuItem value={'createdAt'}>{t('mostRecent')}</MenuItem>
        <MenuItem value={'deliveryDate'}>{t('deliveryDate')}</MenuItem>
      </Select>
    </FormControl>
  );
};
